import  React from "react";
import LedLight from '../components/ledLight'
import "../components css/home.css"
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

 function HomeContent(){

    function activeFun(){
        let home = document.getElementById('fChild')
        let stories = document.getElementById('sChild')
        home.className = '';
        stories.className = 'active'
    }
    let {t} = useTranslation();

 
        
        return(
            <main  style={{overflow:"none"}}>
            <div className='home '>
                <div className="container">
                    <div className="row">
                        <div className='text col-12 col-md-6 col-lg-6 ' >
                            <h1 style={{padding:'20px'}}>{t("HomeTitle")}</h1>
                            <h4>{t('HomeP')}</h4>
                            <div style={{textAlign:"center"}}> 
                                <Link onClick={()=>{activeFun()}}  className="btn btn-white storiesBut" to={"/stories"} >{t('RMore')}</Link>
                            </div>
                        </div>                        
                        
                        <div className='image col-12 col-md-6 col-lg-' style={{textAlign:"center"}}>
                        <img src="https://hassanaliabdelhamed.github.io/Palestinian/images/gaza.png" style={{maxWidth:"100%"}} className="img-fluid" alt="" />
                        </div>

                    </div>
                </div>
            </div>
            <LedLight/>
            </main>
        )
}
export default HomeContent;